module.exports = __webpack_public_path__ + "224ce4b67602f75098269249b4bb1c83.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/chipotle_2023_chart.png
// module id = 1653
// module chunks = 0